<span
  class="ui-avatar"
  role="img"
  [attr.aria-busy]="loading() ? 'true' : null"
  [attr.aria-label]="effectiveAriaLabel()"
  [class.ui-avatar--sm]="size() === 'sm'"
  [class.ui-avatar--md]="size() === 'md'"
  [class.ui-avatar--lg]="size() === 'lg'"
  [class.ui-avatar--xl]="size() === 'xl'"
  [class.ui-avatar--circle]="shape() === 'circle'"
  [class.ui-avatar--square]="shape() === 'square'"
  [class.ui-avatar--tone-neutral]="!loading() && tone() === 'neutral'"
  [class.ui-avatar--tone-primary]="!loading() && tone() === 'primary'"
  [class.ui-avatar--tone-accent]="!loading() && tone() === 'accent'"
  [class.ui-avatar--loading]="loading()"
>
  @if (loading()) {
    <span class="ui-avatar__skeleton" aria-hidden="true"></span>
  } @else if (imageSrc()) {
    <img
      class="ui-avatar__img"
      [src]="imageSrc()!"
      [alt]="imageAlt()"
      loading="lazy"
      decoding="async"
    />
  } @else if (iconSrc()) {
    <img class="ui-avatar__icon" [src]="iconSrc()!" alt="" aria-hidden="true" />
  } @else {
    <span class="ui-avatar__label" aria-hidden="true">{{ initials() }}</span>
  }

  @if (hasBadge() && !loading()) {
    <span
      class="ui-avatar__badge"
      [class.ui-avatar__badge--danger]="badgeTone() === 'danger'"
      [class.ui-avatar__badge--neutral]="badgeTone() === 'neutral'"
      [class.ui-avatar__badge--success]="badgeTone() === 'success'"
      aria-hidden="true"
    >
      {{ badge() }}
    </span>
  }
</span>
